export const cash = "cash";
export const card = "card";